import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map, take} from 'rxjs/operators';
import {AppState} from '@store/state/app.state';
import {Store} from '@ngrx/store';
import * as StorageActions from '@store/actions/storage.action';
import {
    setSelectedBillingAddress,
    setSelectedDeliveryAddress, shoppingCartDynamicArticleIdsCustomer
} from '@store/actions/storage.action';
import {setShoppingCartDynamicArticles} from "@store/actions/shopping-cart.action";
import {getSelectedCustomer} from "@store/selectors/user.selector";

@Injectable()
export class StorageEffects {

    constructor(
        private actions$: Actions,
        private store: Store<AppState>) {
    }



    selectCustomer$ = createEffect(() => this.actions$.pipe(
        ofType(StorageActions.selectCustomer),
        map((action) => {
            let dynamicArticles: { amount: number, id: string }[] = [];
            this.store.select(state => state)
                .pipe(take(1))
                .subscribe(
                    r => {
                        r.user.shopAccessForCustomers?.filter(c => c.customerId == action.customerId).map(c => {
                            // Nur setzen, wenn es sich um einen anderen Customer handelt. Beim Bezahlvorgang über einen externen Zahlungsanbieter wird die Seite verlassen und somit ggf. die Lieferadresse anders gesetzt
                            if (!r.storage.customer?.selectedBillingAddressId &&
                                c.defaultBillingAddressId) {
                                this.store.dispatch(setSelectedBillingAddress({
                                    customerId: action.customerId,
                                    addressId: c.defaultBillingAddressId
                                }));
                            }
                            if (!r.storage.customer?.selectedBillingAddressId &&
                                c.defaultDeliveryAddressId) {
                                this.store.dispatch(setSelectedDeliveryAddress({
                                    customerId: action.customerId,
                                    addressId: c.defaultDeliveryAddressId
                                }));
                            }

                            let dynamicArticleIds: string[] = [], dynamicArticles: { amount: number, id: string }[] = [];

                            // Automatisch hinzugefügte Artikel des zuletzt ausgewählten Kunden löschen
                            this.store.select(state => state.storage).pipe(
                                take(1),
                                map(r => {
                                        r.shoppingCart?.dynamicArticleIds?.customer?.map(
                                            id => {
                                                dynamicArticles.push({amount: 0, id})
                                            }
                                        )
                                    }
                                )
                            );

                            // Artikel von des jetztigen Kunden hinzufügen
                            this.store.select(getSelectedCustomer).pipe(
                                take(1)
                            ).subscribe(
                                customer => {
                                    customer?.dynamicArticleIds?.map(id => {
                                        dynamicArticles.push({ amount: 1, id });
                                    });
                                }
                            );

                            // Daten zwischenspeichern
                            this.store.dispatch(shoppingCartDynamicArticleIdsCustomer({ids: dynamicArticleIds ?? []}))

                            if(dynamicArticles.length > 0){
                                console.log('setDynamicArticlesForCustomer', dynamicArticles);
                                this.store.dispatch(setShoppingCartDynamicArticles({
                                    jsonId: 'user.effects.selectCustomer$',
                                    dynamicArticles
                                }));
                            }

                        });
                    }
                );
        })
    ), {dispatch: false});




}
